<template>

<form id="userForm" class="mx-auto col-12" @submit.prevent>
  <div class="row">

    <div class="form-group col-lg-12" :class="{ 'has-error': errors.has('name') }">
      <label for="name">{{ $t('name') }}</label>
      <input
        type="text"
        id="name"
        name="name"
        class="form-control"
        :placeholder="$t('type_name')"
        v-model="bank.name"
        v-validate="'required'"
        @input="upper('name')"
      />
      <small v-show="errors.has('name')" class="form-text text-muted">
        {{ errors.first('name') }}
      </small>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton @click="onClick">
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div>
</form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'

export default {
  name: 'BankForm',
  components: {
    LoaderButton
  },
  props: {
    bank: {
      type: Object,
      default: () => ({
        id: undefined,
        name: ''
      })
    }
  },
  computed: {
    ...mapState({
      banks: state => state.bank.all
    })
  },
  methods: {
    ...mapActions('banks', [
      'create',
      'edit',
      'cleanState'
    ]),

    async onClick() {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }

      const { id } = this.bank

      const promise = id
                        ? this.edit({ id, data: this.bank })
                        : this.create(this.bank)

      const result = await promise

      if (result) {
        this.$router.push({ name: 'listbanks' })
      }
    },

    upper(attribute) {
      this.bank[attribute] = this.bank[attribute].toUpperCase()
    }
  },
  async mounted () {
  },
  destroyed () {
    this.cleanState()
  }
}
</script>